module.exports = __webpack_public_path__ + "static/media/cg.4396b867.svg";